import React, { useContext, useEffect, useState } from 'react';
import Card from '../layout/Card';
import { ArrowBigDown, ArrowBigUp, Eye } from "lucide-react";
import Loader from './Loader';
import AppContext from '../Context/AppContext';
import axios from 'axios';


import icEmpire from "../assets/logos/logo-empire-str.png";
import icAnime from "../assets/logos/logo-empire-anime.png";
import icSport from "../assets/logos/logo-empire-sport.png";
import icFF from "../assets/logos/logo-filmfy.png";
import StatProjectInfo from './StatProjectInfo';
import StatSport from './StatSport';


/** projects
 * label 
 * project
 * views
 * status : no , up , down
*/


const StatProjects = ({ open }) => {

    const { mapUrl } = useContext(AppContext)
    const mapProjetGeneral = ["_empStrvideo", "_empspovideo"];
    const mapIcone = {
        "_empStrvideo": icEmpire,
        "_empAnivideo": icAnime,
        "_empspovideo": icSport,
        "_ffVideo": icFF
    }
    const repeatTask = 1;

    const mapStatus = {
        "no": <Eye size={15} color='#fff' />,
        "up": <ArrowBigUp size={15} color='#15992f' />,
        "down": <ArrowBigDown size={15} color='#f71717' />
    }

    const [statProject, setStatProject] = useState([]);
    const [error, setError] = useState("");
    const initStatProject = async () => {
        if (mapUrl.stat_all) {
            try {
                const response = await axios.get(mapUrl.stat_all);
                if (response?.data) {

                    setStatProject(prevStatProject => {
                        let result = [];

                        mapProjetGeneral.forEach(element => {
                            const getProject = response.data.find(e => e.project === element);

                            if (getProject) {
                                const getOldStatProject = prevStatProject.find(e => e.project === element);

                                if (getOldStatProject) {
                                    result.push({
                                        ...getProject,
                                        status: getOldStatProject.views <= getProject.views ? "up" : "down"
                                    });
                                } else {
                                    result.push({ ...getProject, status: "no" });
                                }
                            }
                        });

                        return result; // Retourne la nouvelle liste pour `setStatProject`
                    });
                }
            } catch (error) {
                setError("Erreur lors de la récupération des statistiques")
                console.error("Erreur lors de la récupération des statistiques :", error);
            }
        }
    };
    const openTabCenter = (name) => {

        switch (name) {
            case "_empStrvideo":
                return open(<StatProjectInfo label={"Empire Streaming"} targetUrl={"occurence_empire"} />)
                break;
            case "_empAnivideo":
                return open(<StatProjectInfo label={"Empire Anime"} targetUrl={"occurence_empire_anime"} />)
                break;
            case "_empspovideo":
                return open(<StatSport label={"Empire Sport"} targetUrl={"occurence_empire_sport"} />)
                break;
            case "_ffVideo":
                return open(<StatProjectInfo label={"Fimfy"} targetUrl={"occurence_ff"} />)
                break;
            default:
                break;
        }
        return null
    }


    useEffect(() => {
        initStatProject()
        const interval = setInterval(initStatProject, repeatTask * 60 * 1000);

        return () => clearInterval(interval);
    }, [])

    if (error) {
        return <div className='py2'>
            <p className='corange fs16'>{error}</p>
        </div>
    }

    if (!statProject) {
        return <div className='py2'>
            <Loader />
        </div>
    }


    return (
        <div className='df fdc mt1'>
            <p className='fm cw mb1 fs20'>Statistique</p>
            {statProject?.length > 0 && statProject.map((project, project_i) => (
                <div className='mb1' key={project_i + "_stat"}>
                    <Card>
                        <button onClick={() => openTabCenter(project.project)} className='df aic'>
                            <div className='mr3 px1 py1 df aic bcb jc' style={{ borderRadius: "50%" }}  >
                                <img style={{ height: "30px", width: "30px", objectFit: "contain" }} src={mapIcone[project.project]} alt="logo" srcset="" />
                            </div>
                            <div>
                                <p className='fl cw fs12'>{project.label}</p>
                                <div className='df aic'>
                                    <div className='mr1'>
                                        {mapStatus[project.status]}
                                    </div>
                                    <p className='fs28 cw fb'>{project.views}</p>
                                </div>
                            </div>
                        </button>
                    </Card>
                </div>
            ))}
        </div>
    );
};

export default StatProjects;